import { MastraBase } from '../../../base';
import type { ScoreRowData } from '../../../scores/types';
import type { PaginationInfo, StoragePagination } from '../../types';

export abstract class ScoresStorage extends MastraBase {
  constructor() {
    super({
      component: 'STORAGE',
      name: 'SCORES',
    });
  }

  abstract getScoreById({ id }: { id: string }): Promise<ScoreRowData | null>;

  abstract saveScore(score: Omit<ScoreRowData, 'id' | 'createdAt' | 'updatedAt'>): Promise<{ score: ScoreRowData }>;

  abstract getScoresByScorerId({
    scorerId,
    pagination,
    entityId,
    entityType,
  }: {
    scorerId: string;
    pagination: StoragePagination;
    entityId?: string;
    entityType?: string;
  }): Promise<{ pagination: PaginationInfo; scores: ScoreRowData[] }>;

  abstract getScoresByRunId({
    runId,
    pagination,
  }: {
    runId: string;
    pagination: StoragePagination;
  }): Promise<{ pagination: PaginationInfo; scores: ScoreRowData[] }>;

  abstract getScoresByEntityId({
    entityId,
    entityType,
    pagination,
  }: {
    pagination: StoragePagination;
    entityId: string;
    entityType: string;
  }): Promise<{ pagination: PaginationInfo; scores: ScoreRowData[] }>;
}
